import { createFeatureSelector, createSelector } from '@ngrx/store';
import { prepareLoginDashboardFieldsConfig } from '../../adapters/login-dashboard/login-dashboard.adapter';
import { BookWidgetStoreKey } from '../../constants/common.constants';
import { BookWidgetStore } from '../../models/states/book-widget-store.interfaces';

const bookWidgetStoreFeatureSelector =
  createFeatureSelector<BookWidgetStore>(BookWidgetStoreKey);

const getLoginDashboardState = createSelector(
  bookWidgetStoreFeatureSelector,
  (state) => state.loginDashboard
);

export const isLogin = createSelector(
  getLoginDashboardState,
  ({ dashboardResponse }) =>
    !!(dashboardResponse?.loggedIn || dashboardResponse?.isWarmState)
);

export const isBusinessUser = createSelector(
  getLoginDashboardState,
  ({ accountCookieValue }) =>
    !!(
      accountCookieValue?.isBusiness &&
      accountCookieValue?.businessAccountOptionsList
    )
);

export const shouldTriggerLoginDashboardApi = createSelector(
  getLoginDashboardState,
  ({ isReadyOnLanding }) => !isReadyOnLanding
);

export const isLoginDashboardStateReady = createSelector(
  getLoginDashboardState,
  isBusinessUser,
  ({ isReadyOnLanding, isError }, isBusinessUserValue) =>
    !isBusinessUserValue || isReadyOnLanding || isError
);

export const getLoginDashboardFieldsConfig = createSelector(
  getLoginDashboardState,
  isLogin,
  isBusinessUser,
  (
    { accountCookieValue, dashboardResponse, isHipmunk },
    isLoginValue,
    isBusinessUserValue
  ) =>
    prepareLoginDashboardFieldsConfig(
      accountCookieValue,
      dashboardResponse,
      isHipmunk,
      isLoginValue,
      isBusinessUserValue
    )
);
